import { type UseQueryOptions, type UseQueryResult, useQuery } from '@tanstack/react-query';

import { useReduxState } from '@/app/shared/context/ReduxStoreContext';

import { useQueryStateAppContext } from '@/packages/query-state/shared/context/appContext';
import { filtersSelector } from '@/packages/redux-state/store/slices/jsonQuery';

import { type TGetConfigForMapResponse_1 } from '@/repositories/generated/shared/search-offers-index/v1/get-config-for-map';

import { type QueryError, type QueryKey, getQueryKey } from './internal/config';
import { fetchGetConfigForMapService } from './internal/fetchService';

type UseGetOffersQueryOptions<TData> = UseQueryOptions<TGetConfigForMapResponse_1, QueryError, TData, QueryKey>;

export function useGetMapConfigForMapQuery<TData = TGetConfigForMapResponse_1>(
  options?: UseGetOffersQueryOptions<TData>,
): UseQueryResult<TData, QueryError> {
  const applicationContext = useQueryStateAppContext();
  const reduxState = useReduxState();

  return useQuery<TGetConfigForMapResponse_1, QueryError, TData, QueryKey>({
    enabled: false,
    queryFn: () => {
      const jsonQuery = filtersSelector(reduxState.getState());

      return fetchGetConfigForMapService({
        applicationContext,
        parameters: { jsonQuery },
      });
    },
    queryKey: getQueryKey(),
    retry: 1,
    staleTime: Infinity,
    ...options,
  });
}
